<script setup lang="ts">
  import { IconRestore } from '@gat-ship/icons'
  import type { Company } from '@gat-ship/types'
  import {
    Button,
    Modal,
    ModalFooter,
    ModalHeader,
    ModalHeaderTitle,
    ModalSection
  } from '@gat-ship/vue-components'
  import { ref } from 'vue'
  import { useCompanyCollectionContext } from '../../composables/useCompanyCollection'

  const companyProvider = useCompanyCollectionContext()!

  const companyCode = ref<string | undefined>(undefined)

  export interface ActivateCompanyModalParams {
    company: Company
  }

  const isOpen = ref(false)

  function showModal({ company }: ActivateCompanyModalParams) {
    companyCode.value = company.code
    isOpen.value = true
  }

  async function onOkClick() {
    const code = companyCode.value
    if (!code) {
      return
    }
    isOpen.value = false
    await companyProvider.commands.reactivate(code)
  }

  defineExpose({
    showModal
  })
</script>

<template>
  <Modal v-model:open="isOpen">
    <ModalHeader>
      <ModalHeaderTitle>
        <IconRestore />
        Activate Company
      </ModalHeaderTitle>
    </ModalHeader>
    <ModalSection>
      <div class="mb-4">
        <div class="mb-4 text-sm">
          You are about to reactivate this company, which means a few things:
        </div>
        <div class="font-medium">What Happens During Reactivation?</div>
        <div class="mb-2 text-sm">
          The company will be reactivated with it's current name and
          description.
        </div>
      </div>
    </ModalSection>
    <ModalFooter>
      <Button @click="onOkClick">Reactivate</Button>
      <Button variant="ghost" @click="isOpen = false"> Cancel </Button>
    </ModalFooter>
  </Modal>
</template>
